<template>
  <div v-tooltip.left="'Add note'" class="control" title="Add note" @click="setCurrentNote">
    <img src="../../assets/icon_note.svg" style="height: 28px;">
  </div>
</template>

<script>
  export default {
    name: 'CreateNoteButton',
    props: {
      callSid: {
        type: String
      }
    },

    methods: {
      setCurrentNote() {
        this.$store.commit('notes/setCurrentNote', {callSid: this.callSid})
      }
    }
  }
</script>

<style lang="scss">

</style>
